export default "__VITE_ASSET__e6179491__"